import React from 'react';
import MetricsCard from '@/pages/dashboard/components/MetricsCard';
import SvgIcon from '@home/components/SvgIcon';
import { ImagePreview } from 'tea-component';
import errorImg from '@/pages/dashboard/assets/images/funnel/step.png';
import "./index.scss";
import { getLanguage } from '@home/utils/common';
import { useLocal } from '@/pages/dashboard/utils/customHook';
interface FunnelStepCardProps {
  config: {
    dodData: { [key: string]: any; };
    formatRule: any;
  };
  data: {
    funnelCardList: {
      data: {
        card_list: FunnelCard[];
      };
    };
  };
  filterVal: {
    stageList: { code: string; name_ch: string; name_en: string; }[];
  };
  style?: React.CSSProperties;
}
interface FunnelCard {
  lost: {
    show_value: number;
    this_time: string;
    last_time: string;
    this_value: string;
    last_value: number;
  };
  stage_name: string;
  value: string | number;
  stage_image?: string;
}

const FunnelStepCard: React.FC<FunnelStepCardProps> = (props) => {
  const { config, data: propsData, filterVal, style } = props;
  const { data } = propsData?.funnelCardList;
  const { card_list: cardList } = data || {};
  const { dodData, formatRule } = config || {};
  const { isEN } = useLocal();
  
  // 映射筛选器中英文标题文案
  const getMatchedStage = (stageName: string) => 
    filterVal?.stageList?.find((stage) => stage.code === stageName);

  // 根据配置组装对应DodData
  const getDodValues = (item: FunnelCard, isEmptyLost: boolean) => 
    Object.entries(dodData).map(([key, dodItem]: [string, any]) => {
      // 如果是key为折损，并且value是1，则不显示折损
      if (isEmptyLost && key === 'lost') {
        return null;
      }
      const dataToUse = item[key] || {};
      const lastTime = key === 'lost' ? getMatchedStage(item.lost.last_time) : dataToUse.last_time;
  
      return {
        titleEn: dodItem.titleEn,
        titleCn: dodItem.titleCn,
        formatRule: dodItem.formatRule,
        extendFormatRule: dodItem.extendFormatRule,
        thisTime: dataToUse?.this_time,
        lastTime: lastTime ? getLanguage(isEN, lastTime.name_en, lastTime.name_ch) : dataToUse?.last_time,
        value: dataToUse?.show_value,
        thisValue: dataToUse?.this_value,
        lastValue: dataToUse?.last_value,
      };
    }).filter(Boolean); // 把null值过滤掉不显示

  return (
    <div className="dbd-funnel-steps-row">
      {cardList?.map((item: FunnelCard, index: number) => {
        // 折损显隐判断
        const isEmptyLost = Number(item.value) === 1;
        const matchedStage = getMatchedStage(item.stage_name);
        const titleCn = matchedStage ? matchedStage.name_ch : item.stage_name;
        const titleEn = matchedStage ? matchedStage.name_en : item.stage_name;

        const dodValues = getDodValues(item, isEmptyLost);

        return (
          <div key={index} className='dbd-funnel-step-card'>
            <div className="dbd-funnel-step-card-item">
              <MetricsCard
                titleEn={titleEn}
                titleCn={titleCn}
                style={style}
                className={'dbd-funnel-card-box'}
                value={item.value}
                dodData={dodValues}
                formatRule={formatRule}
              />
              {index < cardList.length - 1 && <SvgIcon className="device-icon" type="right-arrow-icon" />}
            </div>
            <div className="dbd-funnel-step-card-img">
              <ImagePreview
                className="device-img"
                modalClassName="device-modal"
                src={item.stage_image || errorImg}
                previewSrc={item.stage_image || errorImg}
                maskClosable={true}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FunnelStepCard;
